import { render, staticRenderFns } from "./AddUpdateRider.vue?vue&type=template&id=0175f816&scoped=true&"
import script from "./AddUpdateRider.vue?vue&type=script&lang=js&"
export * from "./AddUpdateRider.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0175f816",
  null
  
)

export default component.exports